import { Component, OnInit } from '@angular/core';
import { SssoreqService } from '../../../../services/ssoreq.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-dashboard-sso',
  standalone: true,
  imports: [],
  templateUrl: './dashboard-sso.component.html',
  styleUrl: './dashboard-sso.component.css'
})
export class DashboardSsoComponent implements OnInit {
  data: any;
   constructor(
    private api: SssoreqService,
    private msalService: MsalService
  ) {}

  async ngOnInit(): Promise<void> {

    // If not logged in → login first
    /*if (!this.msalService.instance.getActiveAccount()) {
      this.msalService.loginRedirect();
      return;
    }*/

    // API call (token auto-added)
    try {
      const obs = await this.api.testSso();
      if (!obs) {
        return;
      }
      obs.subscribe({
        next: res => this.data = res
      });
    } catch (err) {
    }
  }
}
